<div class="vin-panel">
  <!-- Header con back -->
  <div class="vin-panel-header">
    <button class="btn btn-sm btn-link back-btn" (click)="close()">
      <i class="icon-arrow-left"></i>
    </button>
    <h5>{{ "bastidores.select_from_stock" | translate }}</h5>
  </div>

  <!-- Filtros -->
  <div class="vin-panel-filters">
    <input type="text" class="form-control mb-2" [(ngModel)]="searchTerm"
      placeholder="{{ 'bastidores.search_placeholder' | translate }}" />
    <div class="row">
      <div class="col-6">
        <select class="form-control" [(ngModel)]="filterWorkshop">
          <option value="">{{ "bastidores.all_workshops" | translate }}</option>
          <option *ngFor="let w of workshops" [value]="w">{{ w }}</option>
        </select>
      </div>
      <div class="col-6">
        <select class="form-control" [(ngModel)]="filterState">
          <option value="">{{ "bastidores.all_states" | translate }}</option>
          <option *ngFor="let s of states" [value]="s">{{ ("bastidores.state_" + s) | translate }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Tabla de bastidores -->
  <div class="vin-panel-body">
    <div class="tabla" *ngIf="filteredVins.length > 0; else noResults">
      <div class="table-responsive-wrapper">
        <div class="table-scroll-inner">
          <table class="table full-width-table">
            <thead>
              <tr>
                <th class="cabecera-tabla group-header">{{ "bastidores.group_vehicle" | translate }}</th>
                <th class="cabecera-tabla group-header">{{ "bastidores.group_manufacturer" | translate }}</th>
                <th class="cabecera-tabla group-header">{{ "bastidores.group_status" | translate }}</th>
                <th class="cabecera-tabla group-header"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vin of filteredVins" class="vin-row" (click)="selectVin(vin)">
                <!-- Vehículo -->
                <td class="cell-group">
                  <div class="field-row"><span class="field-label">{{ "bastidores.vin" | translate }}:</span> <span class="field-value vin-value">{{ vin.vin || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "bastidores.license_plate" | translate }}:</span> <span class="field-value">{{ vin.license_plate || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "bastidores.colour" | translate }}:</span> <span class="field-value">{{ vin.colour || '-' }}</span></div>
                </td>
                <!-- Fabricante -->
                <td class="cell-group">
                  <div class="field-row"><span class="field-label">{{ "bastidores.supplier_reference" | translate }}:</span> <span class="field-value">{{ vin.supplier_reference || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "bastidores.vehicle_discount_code" | translate }}:</span> <span class="field-value">{{ vin.vehicle_discount_code || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "bastidores.workshop" | translate }}:</span> <span class="field-value">{{ vin.workshop_name || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "bastidores.manufacture_expected_date" | translate }}:</span> <span class="field-value">{{ vin.manufacture_expected_date || '-' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ "inputs.dealership" | translate }}:</span> <span class="field-value">{{ vin.dealership_name || '-' }}</span></div>
                </td>
                <!-- Estado -->
                <td class="cell-group cell-group-center">
                  <div class="field-row">
                    <span *ngIf="vin.state" class="badge text-badge-list"
                      [ngClass]="vin.state === 'factory' ? 'text-new' : 'text-draft'">
                      {{ ("bastidores.state_" + vin.state) | translate }}
                    </span>
                    <span *ngIf="!vin.state">-</span>
                  </div>
                  <div class="field-row" *ngIf="vin.external_state">
                    <span class="field-label">{{ "bastidores.external_state" | translate }}:</span>
                    <span class="field-value">{{ vin.external_state }}</span>
                  </div>
                  <div class="field-row" *ngIf="vin.is_current">
                    <span class="badge badge-is-current">
                      {{ "bastidores.in_use" | translate }}
                    </span>
                  </div>
                  <div class="field-row" *ngIf="vin.notes">
                    <span class="field-label">{{ "bastidores.notes" | translate }}:</span>
                    <span class="field-value text-truncate-cell">{{ vin.notes }}</span>
                  </div>
                </td>
                <!-- Seleccionar -->
                <td class="select-cell">
                  <i class="icon-checkmark text-success icon-actions"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <ng-template #noResults>
      <div class="no-results">
        <p>{{ "bastidores.no_bastidores" | translate }}</p>
      </div>
    </ng-template>
  </div>
</div>
